import SearchOffRoundedIcon from '@mui/icons-material/SearchOffRounded'
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import HomeRoundedIcon from '@mui/icons-material/HomeRounded'
import { Box, Button, Container, Paper, Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

export default function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <Container maxWidth='md'>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 6,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            width: '100%',
            p: { xs: 4, md: 6 },
            textAlign: 'center',
            borderRadius: 4,
            border: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <SearchOffRoundedIcon
            sx={{
              fontSize: 96,
              color: 'text.secondary',
              mb: 2,
            }}
          />

          <Typography
            variant='h1'
            sx={{
              fontWeight: 700,
              lineHeight: 1,
            }}
          >
            404
          </Typography>

          <Typography
            variant='h4'
            sx={{
              mt: 2,
              fontWeight: 600,
            }}
          >
            Page Not Found
          </Typography>

          <Typography
            color='text.secondary'
            sx={{
              mt: 2,
              maxWidth: 500,
              mx: 'auto',
            }}
          >
            The page you are looking for doesn't exist or may have been moved. Please check the URL
            or return to the home page.
          </Typography>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent='center' mt={5}>
            <Button
              variant='contained'
              size='large'
              startIcon={<HomeRoundedIcon />}
              onClick={() => navigate('/')}
            >
              Go Home
            </Button>

            <Button
              variant='outlined'
              size='large'
              startIcon={<ArrowBackRoundedIcon />}
              onClick={() => navigate(-1)}
            >
              Go Back
            </Button>
          </Stack>
        </Paper>
      </Box>
    </Container>
  )
}
